import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:8000/api/v1",
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    if (err.response?.status === 401) {
      // Tentative de refresh du token
      const refresh = localStorage.getItem("refresh_token");
      if (refresh) {
        try {
          const r = await axios.post(
            `${process.env.REACT_APP_API_URL || "http://localhost:8000/api/v1"}/auth/token/refresh/`,
            { refresh }
          );
          localStorage.setItem("access_token", r.data.access);
          err.config.headers.Authorization = `Bearer ${r.data.access}`;
          return api.request(err.config);
        } catch {
          localStorage.clear();
          window.location.href = "/";
        }
      }
    }
    return Promise.reject(err);
  }
);

/* ─── Profil ──────────────────────────────────────────────────── */
export const getProfile       = ()    => api.get("/api/v1/account/profile/");
export const updateProfile    = (d)   => api.patch("/api/v1/account/profile/", d);
export const uploadAvatar     = (file) => {
  const fd = new FormData();
  fd.append("avatar", file);
  return api.post("/api/v1/account/avatar/", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

/* ─── Sécurité ────────────────────────────────────────────────── */
export const changePassword   = (d)   => api.post("/api/v1/account/password/",   d);
export const get2FASetup      = ()    => api.get("/api/v1/account/2fa/setup/");
export const enable2FA        = (d)   => api.post("/api/v1/account/2fa/enable/",  d);
export const disable2FA       = (d)   => api.post("/api/v1/account/2fa/disable/", d);
export const getActivityLog   = ()    => api.get("/api/v1/account/activity/");

/* ─── Notifications ───────────────────────────────────────────── */
export const getNotifPrefs    = ()    => api.get("/api/v1/account/notifications/");
export const updateNotifPrefs = (d)   => api.patch("/api/v1/account/notifications/", d);

/* ─── Confidentialité ─────────────────────────────────────────── */
export const getPrivacyPrefs  = ()    => api.get("/api/v1/account/privacy/");
export const updatePrivacyPrefs=(d)   => api.patch("/api/v1/account/privacy/", d);

/* ─── Sessions ────────────────────────────────────────────────── */
export const getSessions      = ()    => api.get("/api/v1/account/sessions/");
export const revokeSession    = (id)  => api.delete(`/api/v1/account/sessions/${id}/`);
export const revokeAllSessions= ()    => api.delete("/api/v1/account/sessions/revoke-all/");

/* ─── Gestion du compte ───────────────────────────────────────── */
export const deactivateAccount= (d)   => api.post("/api/v1/account/deactivate/", d);
export const deleteAccount    = (d)   => api.post("/api/v1/account/delete/",     d);
export const requestDataExport= ()    => api.post("/api/v1/account/data-export/");
 
// ── Newsletter ────────────────────────────────────────────────────────────────
export const getNewsletterStatus  = ()    => api.get("/api/v1/account/newsletter/");
export const subscribeNewsletter  = (d)   => api.post("/api/v1/account/newsletter/", d);
export const unsubscribeNewsletter= ()    => api.delete("/api/v1/account/newsletter/");
 
/* ─── Retraits Mobile Money ───────────────────────────────────────────────── */
export const getWithdrawalEligibility = ()     => api.get("/api/v1/account/withdrawal/eligibility/");
export const getMobileWithdrawals     = ()     => api.get("/api/v1/account/withdrawal/mobile/");
export const createMobileWithdrawal   = (d)    => api.post("/api/v1/account/withdrawal/mobile/", d);
export const cancelMobileWithdrawal   = (id)   => api.delete(`/api/v1/account/withdrawal/mobile/${id}/cancel/`);


/* ─── Retraits unifiés (Mobile, Bank, PayPal) ─────────────────────────────── */
export const getPayoutRequests        = ()   => api.get("/api/v1/account/withdrawal/payouts/");
export const createPayoutRequest      = (d)  => api.post("/api/v1/account/withdrawal/payouts/", d);
export const cancelPayoutRequest      = (id) => api.delete(`/api/v1/account/withdrawal/payouts/${id}/cancel/`);


// ═════════════════════════════════════════════════════════════════════════════
// PATCH adminClient.js — Ajouter à la fin, AVANT `export default api;`
// ═════════════════════════════════════════════════════════════════════════════

/* ─── Admin: Payouts unifiés ──────────────────────────────────────────────── */
export const adminGetPayouts      = (p={})  => api.get("/api/v1/admin/withdrawals/payouts/", { params: p });
export const adminApprovePayout   = (id, d) => api.post(`/api/v1/admin/withdrawals/payouts/${id}/approve/`,  d);
export const adminCompletePayout  = (id, d) => api.post(`/api/v1/admin/withdrawals/payouts/${id}/complete/`, d);
export const adminRejectPayout    = (id, d) => api.post(`/api/v1/admin/withdrawals/payouts/${id}/reject/`,   d);

export const getReferralCode    = ()  => api.get("/api/v1/account/referral/code/");
export const getReferralStats   = ()  => api.get("/api/v1/account/referral/stats/");
export const getMyReferrals     = ()  => api.get("/api/v1/account/referral/referrals/");
export const getMyCommissions   = ()  => api.get("/api/v1/account/referral/commissions/");

export const checkReferralCode  = (code) => api.get("/api/v1/account/referral/code/check/", { params: { code } });
export const updateReferralCode = (code) => api.patch("/api/v1/account/referral/code/", { code });

export default api;
